const doc = [({"en":({"title":"Notice", "author":"The Rich Team"}), "ko":({"title":"공지사항", "author":"더리치 개발팀"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;